import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {ReimbursmentModel} from '../../../models/ReimbursmentModel';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ContractTypeService} from '../../general-services/service-contract-type/contract-type.service';
import {UsersService} from '../../users/service/users.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Router} from '@angular/router';
import {ReimbursmentService} from './service-reimbursment/reimbursment.service';
import {ProviderModel} from '../../../models/ProviderModel';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ContractualDataModel} from '../../../models/ContractualDataModel';

@Component({
  selector: 'app-reimbursment',
  templateUrl: './reimbursment.component.html',
  styleUrls: ['./reimbursment.component.scss']
})
export class ReimbursmentComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isReimbursmentSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: ReimbursmentModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(private reimbursmentService: ReimbursmentService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.filter = new ReimbursmentModel();
    this.sectionId = this.SECTIONS.CONTRACTUAL_DATA;
  }

  ngOnInit() {
    this.isReimbursmentSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;

    if (this.showActions === true) {
      this.displayedColumns = ['regionDesc', 'localCustomerDesc', 'contractTypeDesc',
         'resourceUnitCod', 'currencyDesc', 'sizeDesc', 'payment', 'actions'];
    } else {
      this.displayedColumns = ['regionDesc', 'localCustomerDesc', 'contractTypeDesc',
         'resourceUnitCod', 'currencyDesc', 'sizeDesc', 'payment'];
    }

    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.REIMBURSMENT_OFFSET);
    this.getSessionStorageFilter();
    this.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  init() {
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        // tslint:disable-next-line:max-line-length
        if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
          const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
          this.filter.numAnnoMese = numAnnoMese;
        }

        if (!this.reportSection) {
          this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }
        this.loaderService.display(false);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
    });
  }


  getDataPage(offset: Offset, filter: ReimbursmentModel) {
    this.getPageSubscribe = this.reimbursmentService.getPage(offset, filter)
      .subscribe(
        (rFinal: any) => {
          this.dataSource = rFinal.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = rFinal.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const reimbursmentData = this.dataSource.find(data => data.id === id) as ReimbursmentModel, list: GenericArray[] = [
        {id: 'Month', value: this.toCustomStringAnnoMese(reimbursmentData.numAnnoMese)},
        {id: 'Provider Cod', value: this.toCustomString(reimbursmentData.provider.cod)},
        {id: 'Provider Description', value: this.toCustomString(reimbursmentData.provider.description)},
        {id: 'Region Cod', value: this.toCustomString(reimbursmentData.region.cod)},
        {id: 'Region Description', value: this.toCustomString(reimbursmentData.region.description)},
        {id: 'Contract Type Cod', value: this.toCustomString(reimbursmentData.contractType.cod)},
        {id: 'Contract Type Description', value: this.toCustomString(reimbursmentData.contractType.description)},
        {id: 'Local Customer Cod', value: this.toCustomString(reimbursmentData.localCustomer.cod)},
        {id: 'Local Customer Description', value: this.toCustomString(reimbursmentData.localCustomer.description)},
        {id: 'Resource unit Cod', value: this.toCustomString(reimbursmentData.serviceVariant.cod)},
        {id: 'Resource unit Name', value: this.toCustomString(reimbursmentData.serviceVariant.description)},
        {id: 'Currency Cod', value: this.toCustomString(reimbursmentData.currency.cod)},
        {id: 'Currency Description', value: this.toCustomString(reimbursmentData.currency.description)},
        {id: 'Size Cod', value: reimbursmentData.size ? reimbursmentData.size.cod : 'N.D.'},
        {id: 'Size Description', value: reimbursmentData.size ? reimbursmentData.size.description : 'N.D.'},
        {id: 'Compensation Payment', value: this.toCustomString(reimbursmentData.compensationPayment)},
      ],
      dialogRef = this.dialog.open(DialogDetailComponent, {
        width: '40%',
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.REIMBURSMENT_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }


  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
    this.loaderService.display(false);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.REIMBURSMENT_FILTER));
    this.filter = filter_ ? filter_ : new ReimbursmentModel();
  }
}
